import { range } from "@dhx/ts-common/core";
import { stringToDate } from "./DateFormatter";

export class DateHelper {
	static nullTimestampDate = new Date(0);
	static copy(d: Date): Date {
		return new Date(d);
	}
	static fromYear(year: number): Date {
		return new Date(year, 0, 1);
	}
	static fromYearAndMonth(year: number, month: number): Date {
		return new Date(year, month, 1);
	}
	static weekStart(d: Date, firstWeekday: 1 | 0): Date {
		const diff = (d.getDay() + 7 - firstWeekday) % 7;
		return new Date(d.getFullYear(), d.getMonth(), d.getDate() - diff);
	}
	static monthStart(d: Date): Date {
		return new Date(d.getFullYear(), d.getMonth(), 1);
	}
	static yearStart(d: Date): Date {
		return new Date(d.getFullYear(), 0, 1);
	}
	static dayStart(d: Date): Date {
		return new Date(d.getFullYear(), d.getMonth(), d.getDate());
	}
	static addDay(d: Date, count: number = 1): Date {
		return new Date(d.getFullYear(), d.getMonth(), d.getDate() + count);
	}
	static addMonth(d: Date, count: number = 1): Date {
		return new Date(d.getFullYear(), d.getMonth() + count);
	}
	static addYear(d: Date, count: number = 1): Date {
		return new Date(d.getFullYear() + count, d.getMonth());
	}
	static withHoursAndMinutes(d: Date, hours: number, minutes: number, dateFormat: boolean): Date {
		if (dateFormat === undefined || !dateFormat && hours === 12 || dateFormat && hours !== 12) {
			return new Date(d.getFullYear(), d.getMonth(), d.getDate(), hours, minutes);
		} else if (dateFormat && hours === 12) {
			return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, minutes);
		} else {
			return new Date(d.getFullYear(), d.getMonth(), d.getDate(), hours + 12, minutes);
		}
	}
	static setMonth(d: Date, month: number): void {
		d.setMonth(month);
	}
	static setYear(d: Date, year: number): void {
		d.setFullYear(year);
	}
	static mergeHoursAndMinutes(source: Date, target: Date): Date {
		return new Date(source.getFullYear(), source.getMonth(), source.getDate(), target.getHours(), target.getMinutes());
	}
	static isWeekEnd(d: Date): boolean {
		return d.getDay() === 0 || d.getDay() === 6;
	}
	static getTwelweYears(d: Date): number[] {
		const y = d.getFullYear();
		const firstYear = y - y % 12;
		return range(firstYear, firstYear + 11);
	}
	static getWeekNumber(d: Date): number {
		if (d.getDay() !== 6) {
			d = DateHelper.addDay(d, 6 - d.getDay());
		}
		const dayMS = 24 * 60 * 60 * 1000;
		const ordinal = (d.valueOf() - DateHelper.yearStart(d).valueOf()) / dayMS;
		return Math.floor((ordinal - d.getDay() + 10) / 7);
	}
	static isSameDay(d1: Date, d2: Date): boolean {
		return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
	}
	static toDateObject(date: Date | string, dateFormat: string): Date {
		if (typeof date === "string") {
			return stringToDate(date, dateFormat);
		} else {
			return new Date(date);
		}
	}
}